import React from "react"
import get from "lodash.get"
import ImageGallery from "react-image-gallery"
import VideoPlayer from "../video-player"

import { isVideoType } from "../image"
import "./index.css"

const Gallery = ({ items = [] }) => {
  const images = items.map(item => {
    const image = {
      original: get(item, "original.src"),
      description: get(item, "original.title"),
      thumbnail: get(item, "thumbnail.src"),
      renderThumbInner: item => {
        return (
          <img
            src={item.thumbnail || item.original}
            style={{ height: 85, width: "100%" }}
            alt="Thumbnail"
          />
        )
      },
    }
    if (isVideoType(image.original)) {
      image.renderItem = item => {
        return (
          <div>
            <VideoPlayer
              src={item.original}
              style={{ height: "100vh", minHeight: "100%" }}
            />
            <span
              className="image-gallery-description"
              style={{ right: "0", left: "initial" }}
            >
              {item.description}
            </span>
          </div>
        )
      }
    }
    return image
  })

  return <ImageGallery items={images} showPlayButton={false} />
}

export default Gallery
